import { testimonials } from '@/mocks/yokaiManga';

const principles = [
  { icon: 'ri-list-check-3', title: '分类清晰', desc: '按妖精类型与题材整理入口，热门冷门一目了然。' },
  { icon: 'ri-flashlight-line', title: '更新同步', desc: '连载作品最新章节高频同步，追更不等待。' },
  { icon: 'ri-eye-line', title: '点开即看', desc: '无需下载应用，浏览器直接开看，电脑手机都适配。' },
];

export default function About() {
  return (
    <section id="about" className="bg-paper-100 py-14 md:py-20">
      <div className="mx-auto max-w-7xl px-4 md:px-6">
        <div className="grid grid-cols-1 gap-8 lg:grid-cols-2 md:gap-10">
          {/* 品牌介绍 */}
          <div>
            <p className="text-sm font-medium text-primary-600">关于我们</p>
            <h2 className="mt-1 font-serif text-2xl font-bold text-ink-900 md:text-3xl">
              打造妖精漫画的聚合之家
            </h2>
            <p className="mt-4 text-sm leading-7 text-ink-600 md:text-base">
              妖精漫画大全是一个专注于妖精题材漫画的内容聚合网站。我们相信，狐妖的深情、猫妖的俏皮、
              花妖的唯美、雪女的清冷，每一种"妖精"都值得被认真整理与呈现。
            </p>
            <p className="mt-3 text-sm leading-7 text-ink-600 md:text-base">
              从首屏到合集，从热门推荐到冷门挖掘，我们以清晰分类与聚合入口，帮每一位读者快速找到心仪之作，
              让"点开即看"成为最自然的事。
            </p>

            <div className="mt-7 flex flex-col gap-4">
              {principles.map((item) => (
                <div key={item.title} className="flex items-start gap-4">
                  <span className="flex h-11 w-11 shrink-0 items-center justify-center rounded-xl bg-primary-500 text-lg text-paper-50">
                    <i className={item.icon} aria-hidden="true"></i>
                  </span>
                  <div>
                    <h3 className="font-serif text-base font-bold text-ink-900">{item.title}</h3>
                    <p className="mt-1 text-sm text-ink-500">{item.desc}</p>
                  </div>
                </div>
              ))}
            </div>
          </div>

          {/* 读者口碑 */}
          <div>
            <h2 className="font-serif text-2xl font-bold text-ink-900 md:text-3xl">读者口碑</h2>
            <p className="mt-2 text-sm text-ink-500">来自众多妖精漫画读者的真实反馈。</p>
            <div className="mt-6 flex flex-col gap-4">
              {testimonials.map((item) => (
                <figure
                  key={item.name}
                  className="rounded-2xl border border-paper-200 bg-paper-50 p-5"
                >
                  <div className="flex items-center gap-1 text-accent-500">
                    {Array.from({ length: 5 }).map((_, i) => (
                      <i key={i} className="ri-star-fill text-sm" aria-hidden="true"></i>
                    ))}
                  </div>
                  <blockquote className="mt-3 text-sm leading-7 text-ink-700">
                    “{item.text}”
                  </blockquote>
                  <figcaption className="mt-4 flex items-center gap-3">
                    <img
                      src={item.avatar}
                      alt={`${item.name}的头像`}
                      className="h-10 w-10 rounded-full object-cover"
                    />
                    <div>
                      <div className="text-sm font-semibold text-ink-900">{item.name}</div>
                      <div className="text-xs text-ink-400">{item.role}</div>
                    </div>
                  </figcaption>
                </figure>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}